import { ColorOptions, IconButton, LoaderNew, ModBox, SpacerNew, Text, TextNew } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../../../../data/store'
import { ImgPDFComponent } from '../ImagePdfComponent'

const ButtonComp = ({ kycDoc, onPressButton }: any) => {
  const handleOnDocViewPress = () => {
    onPressButton && onPressButton(kycDoc)
  }
  return (
    <ModBox
      onPress={handleOnDocViewPress}
      backgroundColor={'PRIMARY'}
      borderRightWidth={1}
      borderBottomWidth={1}
      borderBottomColor={'WHITE'}
      borderRightColor={'WHITE'}
      underlayColor={'DARK_GREY'}
      padding={4}>
      <TextNew title={kycDoc?.MERCHANT_DOCUMENT_TYPE} color={'WHITE'} fontSize={12} />
    </ModBox>
  )
}
const MultipleDocsView = ({ flowType, item, onBackPress, entityId }: any) => {
  const { downloadKycImage, getMultipleKycDocumentsList } = useStores((root) => ({
    downloadKycImage: root?.downloadKycImage,
    kycDocumentDownloadFetch: root?.kycDocumentDownloadFetch,
    getMultipleKycDocumentsList: root?.getMultipleKycDocumentsList,
  }))
  const [imgUri, setImgUri] = useState('')
  const [fetchImage, fetchImageHandler] = useLazyApiData(downloadKycImage)
  // const [fetchKycDocumentDownload, kycDownloadHandler] = useLazyApiData(kycDocumentDownloadFetch)
  const [kycDocsList, setKycDocsList] = useState([])
  const [selectedDocToView, setSelectedDocToView] = useState(null)

  const handleOnDocViewPress = (itemData: any) => {
    setSelectedDocToView(itemData)
    console.log('kycDocsList handleOnDocViewPress', JSON.parse(JSON.stringify(itemData)))
    fetchImage(
      entityId,
      itemData,
      selectedDocToView?.NAME?.toLowerCase()?.includes('.pdf')
        ? 'PDF'
        : `.${selectedDocToView?.NAME?.toUpperCase()?.split('.')?.[1]}`,
    )
  }

  useEffect(() => {
    const data = item?.kycDocuments ? item?.kycDocuments : getMultipleKycDocumentsList(item)
    setKycDocsList(data)
    if (data && data?.length > 0) {
      handleOnDocViewPress(data?.[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (fetchImageHandler.state === 'fulfilled') {
      if (fetchImageHandler?.data !== 'failed') {
        setImgUri(fetchImageHandler?.data)
      } else {
        onBackPress()
      }
    } else if (fetchImageHandler.state === 'rejected') {
      onBackPress()
    }
  }, [fetchImageHandler?.data, fetchImageHandler.state, onBackPress])

  const onDownloadPress = () => {
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = imgUri
    a.download = item?.NAME?.length > 0 && item?.NAME?.includes('.pdf') ? item?.NAME : selectedDocToView?.NAME
    a.click()
    // window.URL.revokeObjectURL(imgUri)
    document.body.removeChild(a)
  }

  return (
    <>
      <ModBox
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
        overflow={'auto'}
        w={1024}
        minHeight={700}
        h={'100%'}>
        <ModBox w={'100%'} alignItems={'flex-start'} justifyContent={'space-between'}>
          <ModBox direction="row" w={'25%'}>
            <IconButton id="ARROW_BACK" onPress={onBackPress} size={20} color="WHITE" height={24} width={24} />
            <SpacerNew size={24} direction="horizontal" />
            <Text
              numberOfLines={6}
              title={`${item?.MERCHANT_DOCUMENT_TYPE} Document`}
              color={'WHITE'}
              fontFamily="jiotype-bold"
              fontSize={18}
            />
          </ModBox>
          <ModBox width={1024} h={'100%'}>
            <ModBox direction="row" flexWrap={'wrap'} justifyContent={'center'} w={'100%'} marginVertical={16}>
              {kycDocsList &&
                kycDocsList?.length > 0 &&
                kycDocsList?.map((kycDoc) => {
                  return <ButtonComp kycDoc={kycDoc} onPressButton={handleOnDocViewPress} />
                })}
            </ModBox>
            <ModBox borderRadius={16} backgroundColor={'#E8E8E8' as ColorOptions} width={'100%'} minHeight={700}>
              <ModBox
                show={fetchImageHandler?.state !== undefined && fetchImageHandler?.state === 'pending'}
                w={'100%'}
                h={'100%'}
                alignItems={'center'}
                justifyContent={'center'}>
                <LoaderNew color={'PRIMARY'} type={'large'} />
              </ModBox>
              <ModBox
                width={'100%'}
                minHeight={700}
                backgroundColor={'#E8E8E8' as ColorOptions}
                borderRadius={16}
                marginTop={selectedDocToView?.NAME?.toLowerCase()?.includes('.pdf') ? 32 : 16}>
                <ImgPDFComponent
                  type={
                    selectedDocToView?.NAME?.toLowerCase()?.includes('.pdf')
                      ? 'PDF'
                      : selectedDocToView?.NAME?.toLowerCase()?.includes('.png')
                      ? 'PNG'
                      : selectedDocToView?.NAME?.toLowerCase()?.includes('.jpg') ||
                        selectedDocToView?.NAME?.toLowerCase()?.includes('.jpeg')
                      ? 'JPG'
                      : `.${selectedDocToView?.NAME?.toUpperCase()?.split('.')?.[1]}`
                  }
                  imgUri={imgUri}
                  onDownloadPress={onDownloadPress}
                />
              </ModBox>
            </ModBox>
          </ModBox>
        </ModBox>
      </ModBox>
    </>
  )
}

export { MultipleDocsView }
